module.exports = __webpack_public_path__ + "static/media/firebasesvg1.1c973c35.svg";